<template>
  <div class="page" v-wechat-title="$route.meta.title">

    <!--轮播图-->
    <div class="swiper-con border-box" style="position: relative;">
      <Swiper :banners="banners" :type="'spot'"></Swiper>
    </div>

    <!--景区详情内容-->
    <div class="tab-scenic-box">
      <!--景区信息-->
      <div class="scenic-padding scenic-details-box border-box">
        <div class="scenic-details border-box">
          <div class="scenic-details-title border-box">{{spotid?'景点介绍':'场所介绍'}}</div>
          <div class="scenic-details-info mt13" v-if="(shop.info=='')||(shop.info==null)||(!shop.info)">暂无介绍</div>
          <div class="scenic-details-info mt13" v-html="shop.info" v-else></div>
        </div>
      </div>
      <!--分隔行-->
      <div class="split-line h13"></div>
      <!--景区助手-->
      <div class="scenic-padding border-box" v-if="spotid">
        <div class="scenic-details-title">景区助手</div>
        <div class="scenic-details-info mt13">建议游玩时长：{{shop.routetime?shop.routetime:'暂无建议'}}</div>
      </div>
      <div class="scenic-padding border-box" v-if="serviceid && shop.tag">
        <div class="scenic-details-title">标签</div>
        <div class="scenic-details-info mt13">{{shop.tag}}</div>
      </div>

      <!--分隔行-->
      <div class="split-line h13" v-if="serviceid && shop.address"></div>
      <div class="scenic-padding border-box" v-if="serviceid && shop.address">
        <div class="scenic-details-title">地址</div>
        <div class="scenic-details-info mt13">{{shop.address}}</div>
      </div>
    </div>

    <!--新增评论头部-->
    <!--
    <div v-if="spotid">
      <div class="split-line h13"></div>
      <div class="comments-list-top clearfix border-box" id="comments-list-top">
        <span class="fl">游客点评</span>
        <div class="star-box-new clearfix">
          <img :src="(score>=2)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <img :src="(score>=4)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <img :src="(score>=6)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <img :src="(score>=8)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <img :src="(score>=10)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <span>{{score}}分</span>
        </div>

      <span @click="commentShow=1" class="fr commentBtn">我要点评
        <img src="../../assets/icon-write.png" />
      </span>
      </div>
      <div class="comments-list border-box account-list-sr">
        <div v-for="(item,index) in commentList" :key="index" class="comments-list-data box border-box">
          <p class="block head-img-box">
            <img class="img" v-lazy="item.rzimg?item.rzimg:item.headimg" :key="item.rzimg?item.rzimg:item.headimg"/>
          </p>

          <div class="flex comments-list-info  border-box">
            <div class="comments-person-box box ">
              <div class="block comments-person">
                <p class="comments-person-name hide">{{item.name}}</p>
                <p class="star-level">
                  <template v-for="(star,index) in [2,4,6,8,10]">
                    <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                    <img v-else  src="../../assets/start_nor.png" />
                  </template>
                  <span class="icon-reward-small" v-if="item.isds&&res.noReward!=1">赏</span>
                </p>
              </div>
            </div>

            <div class="comments-detail border-box">
              <p class="comments-detail-top">{{item.content}}</p>
            </div>

            <div v-if="item.allimg" class="comments-img box border-box">
              <img v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite"  :key="ite"/>
            </div>

            <div class="block comments-person-time">
              {{item.addtime}}
            </div>

          </div>
        </div>
        <div class="bottom-box border-box">
          <p class="select-more" v-if="commentListLen>0">共{{commentListLen}}条评论</p>
          <p class="select-more" v-else>暂无评论</p>
        </div>
      </div>
    </div>
    -->


    <div class="comment-btn-box" @click="backListen" v-if="url"><p class="comment-btn">去听解说</p></div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

    <!--新版本评论弹窗8-21-->
    <AlertComment :page="'maptour'" :shopid="shopid" :spotid="spotid" :class="{'curr':commentShow==1,'none':commentShow!=1}"  @child-Comment="closeComment"></AlertComment>
  </div>

</template>

<script>
  import Swiper from '../../components/Swiper'
  import AlertComment from '../../components/AlertComment'
  import {mapSpotDetail,mapServiceDetail,mapSpotComment} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, getWxMini,wxImgPreview} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        code: this.$route.query.code || '', //城市站点id
        spotid: this.$route.query.spotid || '', //景点id
        shopid: this.$route.query.shopid || '', //景区id
        serviceid: this.$route.query.serviceid || '', //服务点位id
        userInfo: {}, //用户信息
        loadText: "数据加载中",

        res: "", //全部数据
        shop: '', //景点详情
        banners: [],
        url: '', //语音
        islisten: 0, //是否要去听解说
        commentShow: 0, //弹出评论弹窗
        commentList:[],//评论数据
        commentListLen:0,//评论条数
        score: 10, //评分

        appKey: '',
        appKeyA: '',


        P400: 0, //系统维护中

        isWxMini: false, //返回是否是小程序环境
      }
    },
    computed: {

    },
    created(){

      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }

      if(this.spotid){
        this.mapSpotDetailFun();
//        this.mapSpotCommentFun();
      }else if(this.serviceid){
        this.mapServiceDetailFun()
      }

    },

    beforeRouteLeave(to, from, next) {
      if(this.url && this.islisten){
        to.query.listenId = this.spotid
      }
      console.log(to);
      next();
    },
    methods: {

      //获取景点信息
      async mapSpotDetailFun(){
        let res = await mapSpotDetail({
          id: this.spotid,
        });

        if (res.errcode === "00000"){
          var spot = res.data.spot;
          var imgarr = spot.allimg.split(',');
          this.banners = imgarr;
          this.shop = spot;
          this.url = res.data.url;
          this.$route.meta.title = spot.name;

          let title = spot.name + ' | 一图游地图导览';
          let desc = '一图在手，说走就走；历史会说话！金牌解说与您共享景区故事~';
          let link = '/map-tour?shopid='+this.shopid + '&appKey=' + this.appKey;
          wxShareme(title, desc, spot.logo, link);

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },
      //获取景点评论
      async mapSpotCommentFun(){
        let res = await mapSpotComment({
          spotid: this.spotid,
        });

        if (res.errcode === "00000"){
          if (res.data.root.length > 0) {
            this.commentList = res.data.root;
            this.commentListLen = res.data.total;
            if(res.data.score>0){
              this.score = res.data.score
            }
          }
        }
      },

      //获取服务点位信息
      async mapServiceDetailFun(){
        let res = await mapServiceDetail({
          id: this.serviceid,
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          var imgarr = res.data.allimg.split(',')
          this.banners = imgarr;
          console.log(imgarr)

          this.shop = res.data;
          this.$route.meta.title = res.data.name;

          let title = res.data.name + ' | 一图游地图导览';
          let desc = '一图在手，说走就走；历史会说话！金牌解说与您共享景区故事~';
          let link = '/map-tour?shopid='+this.shopid + '&appKey=' + this.appKey;
          wxShareme(title, desc, res.data.logo, link);

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //去听解说
      backListen: function (){
        this.islisten = 1;
        this.$router.back();
      },

      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      },
      //评论弹窗隐藏
      closeComment :function(msg){
        this.commentShow = msg.commentShow;
        if(msg.success){
          this.mapSpotCommentFun();
        }
      },


    },

    components: {
      Swiper,
        P400,
        AlertComment
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }

  }

</script>

<style scoped>
  @import '../../style/alert.css';

  .page{ overflow-x: hidden;}

  /*轮播图*/
  .swiper-con{width:100%;height: 3.85rem;}
  .swiper-box,.swiper-box .swiper-container{border-radius: 0!important;}
  .swiper-box .swiper-pagination{bottom: .4rem;}

  .tab-scenic-box *{white-space: normal!important;}
  /*新版景区景点详情*/
  .scenic-padding{padding:.26rem .24rem;background:#fff;font-weight:bold;color:#555;}
  .scenic-details-box{position:relative;background: #fff;}
  .scenic-details-box.curr .scenic-details{height:auto;}
  .scenic-details-title{position:relative;font-size:.3rem;}
  .scenic-details-info{line-height:.4rem;font-size:.26rem;font-weight: normal;}
  .scenic-details-box.curr .toggle-slide image{-webkit-transform:rotate(180deg);transform:rotate(180deg);}

  .comment-btn-box{position:fixed;left:0;bottom:0;z-index:2;height:1.4rem;width:100%;background:#fff;}
  .comment-btn{position:absolute;left:.24rem;right:.24rem;top:50%;height:.70rem;line-height:.70rem;margin-top:-.35rem;color:#fff;background:#faaf39;border-radius:.30rem;text-align:center;letter-spacing:.05rem;font-size:.32rem;}


  /*新增底部评论详情列表*/
  .comments-list{width:100%;padding:.36rem 0  .16rem .24rem; margin-bottom: 0; }
  .comments-list-top{width:100%;height:.88rem;padding:0 .22rem;margin-top: .2rem;border-bottom:1px solid #F0F0F0;}
  .comments-list-top .fl{font:bold .32rem/.88rem "Microsoft YaHei";color:#333;}
  .comments-list-top .fr{font:.28rem/.88rem "Microsoft YaHei";color:#666;}
  .comments-list-top .fr img{float:right;width:.29rem;height:.32rem;margin:.28rem 0 0 .16rem;}
  .comments-list .bottom-box{position:relative;height:.88rem;background:#fff;padding-right: .24rem;}
  .select-more{height:.88rem;line-height:.88rem;font-size:.30rem;color:#faaf39;text-align:center;background: none;}

  .star-box-new{ display: inline-block; height:.42rem;margin-top: .25rem;margin-left: .12rem;}
  .star-box-new img{float:left;width: auto;height: .25rem;margin-right: .09rem;margin-top: .085rem;}
  .star-box-new span{float: left;margin-left:.13rem;font: .24rem/.44rem "Microsoft YaHei";color: #c6c6c6;}

  /* 台式电脑显示器屏幕字体大小 */
  @media screen and (min-width: 1000px) {
    .swiper-con{height: 50vh;}
  }
</style>



// WEBPACK FOOTER //
// src/page/map/map-desc.vue